import {
  ExpressCheckout,
  ClarityEventTracker,
  LogErrorReporter,
  SlackErrorReporter,
} from '@appmax_npm/lib-express-checkout'
import getMerchantSessionUrl from '@/utils/ApplePay/getMerchantSessionUrl'
import ApplePayService from '@/utils/ApplePay/ApplePayService'
import { saveApplePaymentInfo } from '@/utils/ApplePay/applePayPaymentInfoStorage'
import { isProduction } from '@/utils/environment'

const clarityEventTracker = new ClarityEventTracker()

const getErrorReporter = () => {
  if (isProduction()) {
    return new SlackErrorReporter(process.env.VUE_APP_SLACK_EXPRESS_CHECKOUT_WEBHOOK_URL)
  }
  return new LogErrorReporter()
}

export default function getApplePayInstance(cart = {}, installment = '0') {
  async function onPaymentAuthorized(appleToken) {
    const applePayService = new ApplePayService()
    try {
      saveApplePaymentInfo(appleToken, installment)
      return await applePayService.pay({ appleToken, cart, installment })
    } catch (error) {
      throw Error(error)
    }
  }

  let merchantCapabilities = ['supports3DS', 'supportsCredit']

  if (+installment === 1) {
    merchantCapabilities = [...merchantCapabilities, 'supportsDebit']
  }

  const merchantSessionUrl = getMerchantSessionUrl()
  const configs = {
    data: {
      cart: cart.hash
    },
    merchantSession: {
      url: merchantSessionUrl
    },
    merchantIdentifier: 'merchant.br.com.appmax.applepay',
    merchantCapabilities,
    supportedNetworks: ['visa', 'masterCard', 'elo', 'amex'],
    countryCode: 'BR',
    onPaymentAuthorized,
  }

  const options = {
    eventTracker: clarityEventTracker,
    errorReporter: getErrorReporter()
  }

  return new ExpressCheckout(configs, options)
}
